import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ButtonComponent } from '@shared/components/button/button.component';
import { Order } from '@b2b/features/order/utilities/order.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'cart-totals',
  imports: [CommonModule, ButtonComponent, TranslateModule],
  templateUrl: './cart-totals.component.html',
  styleUrl: './cart-totals.component.scss',
})
export class CartTotalsComponent {
  #translate = inject(TranslateService);
  continueOrderTranslate = toSignal(this.#translate.get('cart.summaryTotals.continueOrder'));

  @Input() cart!: Order;
  @Input() buttonText?: string = this.continueOrderTranslate();
  @Input() disableButton: boolean = false;
  @Input() insideButton?: boolean = true;
  @Input() showButton?: boolean = true;
  @Input() isLoadingButton?: boolean = false;

  @Output() buttonClick = new EventEmitter<void>();

  constructor() {}

  get totalFactory() {
    const total = Number(this.cart.totalFactoryPrice) || 0;

    return total === 0
      ? '-'
      : total.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
  }

  get totalValue() {
    const total = Number(this.cart.totalPrice) || 0;

    return total === 0
      ? '-'
      : total.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
  }

  get discountValue() {
    const total = Number(this.cart.totalDiscounts) || 0;

    return total === 0
      ? '-'
      : '-' +
          total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
  }

  get taxValue() {
    const total = Number(this.cart.totalTax) || 0;

    return total === 0
      ? '-'
      : '+' +
          total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          });
  }

  onButtonClick() {
    this.buttonClick.emit();
  }
}
